var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVaccine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8596 12.8255L19.0657 8.13734C19.0212 8.0938 18.9683 8.05926 18.9101 8.03569C18.852 8.01213 18.7897 8 18.7267 8C18.6637 8 18.6014 8.01213 18.5432 8.03569C18.485 8.05926 18.4322 8.0938 18.3876 8.13734L10.0812 16.2607L10.0808 16.2611L8.00089 18.2951C7.36003 18.9218 7 19.7718 7 20.6581C7 21.097 7.08839 21.5315 7.26012 21.937C7.43186 22.3425 7.68357 22.7109 8.00089 23.0212C8.31822 23.3315 8.69493 23.5777 9.10953 23.7457C9.52413 23.9136 9.96849 24 10.4173 24C11.3236 24 12.1928 23.6479 12.8336 23.0212L19.0628 16.9294L19.0629 16.9292L21.862 14.1919L23.6721 13.6018C23.7497 13.5765 23.8193 13.5323 23.8744 13.4733C23.9295 13.4143 23.9684 13.3425 23.9871 13.2648C24.0059 13.187 24.0041 13.1058 23.9818 13.0289C23.9594 12.9521 23.9174 12.882 23.8596 12.8255ZM12.1556 22.3582C11.6933 22.8031 11.0699 23.0515 10.4213 23.049C9.77261 23.0465 9.15124 22.7933 8.69256 22.3448C8.23388 21.8962 7.97506 21.2886 7.9725 20.6542C7.96995 20.0198 8.22385 19.4102 8.67891 18.9581L10.7319 16.9503C10.9049 16.8286 12.2377 15.9777 14.3576 17.0144C15.2866 17.4686 16.1047 17.6219 16.7862 17.6219C16.861 17.6219 16.9334 17.6193 17.005 17.6157L12.1556 22.3582ZM21.4514 13.3374C21.3808 13.3604 21.3167 13.3992 21.264 13.4507L18.4121 16.2397C18.2392 16.3615 16.9062 17.2124 14.7863 16.1757C13.7557 15.6717 12.8618 15.5389 12.1391 15.5742L18.7267 9.13186L22.6332 12.9522L21.4514 13.3374Z",
    fill: "url(#paint0_linear_3410_9310)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3410_9310",
    x1: 22.6211,
    y1: 8,
    x2: 13.1549,
    y2: 18.5554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccine);
export default __webpack_public_path__ + "static/media/vaccine.fa8fef59.svg";
export { ForwardRef as ReactComponent };